module.exports = __webpack_public_path__ + "media/images/application/icons/facebook-logo-ba435dc170a509ed9109422f6679d54c.svg";